import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { updateItemAsync } from "actions/items";
import ImageEditor from "components/library/ImageEditor";

class PrimaryImageEditor extends React.Component {
  constructor(props) {
    super(props);
    this.onSuccess = this._onSuccess.bind(this);
  }

  _onSuccess(image) {
    return this.props.updateItemAsync(this.props.match.params.id, {
      primary_image: image.id,
      head_rev: this.props.head_rev,
    });
  }

  render() {
    return (
      <ImageEditor
        {...this.props}
        redirectTo={`/editor/${this.props.match.params.type}/${this.props.match.params.id}/`}
        onSuccess={this.onSuccess}
        imageRequirements={{
          minWidth: 1280,
          minHeight: 720,
        }}
        cropRequirements={{
          "16x9": {
            minWidth: 1280,
            minHeight: 720,
          },
          "4x3": {
            minWidth: 960,
            minHeight: 720,
          },
          "1x1": {
            minWidth: 720,
            minHeight: 720,
          },
        }}
      />
    );
  }
}

PrimaryImageEditor.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      type: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
    }),
  }),
  updateItemAsync: PropTypes.func.isRequired,
  head_rev: PropTypes.string,
};

const mapStateToProps = state => ({
  head_rev: state.editor.form.head_rev,
});

const mapDispatchToProps = {
  updateItemAsync,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PrimaryImageEditor);
